import AdyenCreditCardForm from './adyen-credit-card-form';

export default AdyenCreditCardForm;
